'use client';

import Link from 'next/link';
import type { FC } from 'react';

type PropType = {
  blogHref: string;
};
const BlogNotFound: FC<PropType> = ({ blogHref }) => {
  return (
    <main className="error-page">
      <div className="container">
        <div className="error-wrapper">
          <h2>404</h2>
          <p>The page you are looking for cannot be found.</p>

          <p>
            <Link href={blogHref}>
              <button className="colored">All Articles</button>
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
};

export default BlogNotFound;
